module.exports = __webpack_public_path__ + "static/media/thursday-in-spanish.9ef3e6d8.png";